import React from "react";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import Page from "../layout/Page";

const ErrorPage = ({ children, match }) => {
  const { params } = match;

  const Header = (
    <div>
      <Typography variant="h1" color="textPrimary">
        Oh no, looks like we ran into an error
      </Typography>
    </div>
  );

  return (
    <Page header={Header} footer={children}>
      <Typography variant="body1" color="textSecondary">
        This was unexpected and reported to our support team to be addressed as
        soon as possible. Below are some possible solutions that you can do as
        well:
      </Typography>
      <Link to={`/${params.accountId}`}>
        <Typography variant="h2">Try Starting Over Again</Typography>
      </Link>
    </Page>
  );
};

export default ErrorPage;
